import { Button } from 'antd';
import styled, { keyframes } from 'styled-components';

type ContainerProps = {
  $isMobileVersion: boolean;
};

const pulse = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(114, 46, 209, 0.4);
  }
  70% {
    box-shadow: 0 0 0 12px rgba(114, 46, 209, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(114, 46, 209, 0);
  }
`;

export const Container = styled.div<ContainerProps>`
  position: fixed;
  right: ${({ $isMobileVersion }) => ($isMobileVersion ? '16px' : '24px')};
  bottom: ${({ $isMobileVersion }) => ($isMobileVersion ? '16px' : '24px')};
  z-index: 999;
`;

export const FloatingButton = styled(Button).attrs({
  shape: 'circle',
})`
  && {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 56px;
    height: 56px;
    font-size: 22px;
    background: #722ed1;
    border-color: #722ed1;
    color: #fff;
    box-shadow: 0 4px 12px rgba(114, 46, 209, 0.35);
    transition: all 0.3s ease;
    animation: ${pulse} 2s ease-out 3;

    &:hover,
    &:focus {
      background: #9254de;
      border-color: #9254de;
      transform: scale(1.1);
      box-shadow: 0 6px 16px rgba(114, 46, 209, 0.4);
    }

    &:active {
      background: #531dab;
      border-color: #531dab;
      transform: scale(0.95);
    }
  }
`;

export const TooltipContent = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
`;
